import type { EventModule } from '../../types/event';

export const EVENT_CODES = {
  typingContest2026: 'typing-contest2026',
} as const;
export type EventCode = (typeof EVENT_CODES)[keyof typeof EVENT_CODES];

export const getEventAssetPath = (eventCode: EventCode, ...paths: string[]) =>
  `/events/${eventCode}/${paths.join('/')}`;

export const getCommonAssetPath = (...paths: string[]) =>
  `/events/common/${paths.join('/')}`;

export const eventModules: Record<string, () => Promise<{ default: EventModule }>> = Object.fromEntries(
  Object.values(EVENT_CODES).map((code) => [
    code,
    () => import(`./${code}/module.ts`),
  ]),
);
